import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import Collapse from "react-bootstrap/Collapse";
import Select from 'react-select';
import ProductServices from "../../../services/ProductServices";
import IventoryAddModal from '../Inventory/IventoryAddModal'
import Pagination from "../Pagenation/Pagenation";
import Loader from "../Loader/loader";


const MasterListinv = () => {
  const [open, setOpen] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [sort, setsort] = useState(150) // Number of items per page
  const [activePag, setActivePag] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState();


  //Display row 
  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];




  // Fetch data from API
  useEffect(() => {
    setLoading(true); // Start loader
    ProductServices.getAllProduct()
      .then((response) => {
        setData(response?.data?.data || []);
        setLoading(false); // Stop loader once data is set
      })
      .catch((error) => {
        setError("There is some problem in fetching data!");
        setLoading(false); // Stop loader on error
      });
  }, []);

  //end

  const handleEditClick = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };
  // Pagination setup
  useEffect(() => {
    if (searchTerm) {
      const filtered = data.filter(
        (item) =>
          String(item?.partNo)
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.category?.name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchTerm, data]);

  useEffect(() => {
    setActivePag(0);
  }, [filteredData, sort]);

  const pagination = Math.ceil(filteredData.length / sort);

  const currentData = filteredData.slice(
    activePag * sort,
    (activePag + 1) * sort
  );

  const onClick = (page) => {
    setActivePag(page);
  };

  const handleSelectChange = (selectedOption) => {
    setsort(selectedOption.value);
    setActivePag(0);
  };


  return (
    <>
      <IventoryAddModal
        show={gridInsideModal}
        handleClose={() => setGridInsideModal(false)}
        item={selectedItem}
      />
      <div className="row">
        {loading ? (
          <Loader />
        ) : (
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6">
                        <label className="form-label ms-2">Search Inventory</label>
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="searchInput"
                          placeholder="Search by Part No., Category, or Description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-3 col-xxl-6">
                        <label className="form-label ms-2">Select Display Rows</label>
                        <Select
                          placeholder="Select rows to display in User Table"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-plus me-2" aria-hidden="true"></i>Add Inventory
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer "
                      >

                        <div className="scrolltable">
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead className="sticky-table-header">
                              <tr>
                                <th>S.No</th>
                                <th>Part No.</th>
                                <th>Image</th>
                                <th>Category</th>
                                <th>Unit</th>
                                <th>Description</th>
                                <th>Remark</th>
                                <th className="text-end">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(filteredData) &&
                                filteredData.length > 0 ? (
                                currentData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{activePag * sort + index + 1}</td>
                                    <td>{item?.partNo}</td>
                                    <td>
                                      {item.image ? (
                                        <img
                                          src={`https://indigoinfra.in/img/product/${item.image}`}
                                          alt={item.partNo}
                                          className="thumbnail-image"
                                        />
                                      ) : (
                                        "No image available"
                                      )}
                                    </td>
                                    <td>{item?.category?.name}</td>
                                    <td>{item?.unit?.name}</td>
                                    <td className="scrollable-description">{item?.description}</td>
                                    <td className="scrollable-description">{item?.remark}</td>
                                    <td className="text-end">
                                      <td className="text-center"><i class="fa fa-plus" aria-hidden="true" onClick={() => handleEditClick(item)}></i></td>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">
                                    No records found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {filteredData.length === 0 ? 0 : activePag * sort + 1} to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePag + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>
                          <Pagination
                            activePage={activePag}
                            totalPages={pagination}
                            onPageChange={onClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MasterListinv;
